import { createSlice } from '@reduxjs/toolkit';
import { throttleQueueAddAction, throttleQueueUpdateAction, throttleSentAction } from '../actions/Throttle';
const initialState = {};
export const throttleSlice = createSlice({
    name: 'throttle',
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(throttleQueueAddAction, (state, action) => {
            state[action.payload.endpoint] = {
                timestamp: Date.now(),
                post: {
                    data: action.payload.data,
                    success: action.payload.success,
                    failure: action.payload.failure,
                    intervalId: action.payload.intervalId
                }
            };
        })
            .addCase(throttleQueueUpdateAction, (state, action) => {
            state[action.payload.endpoint] = {
                timestamp: Date.now(),
                post: {
                    data: action.payload.data,
                    success: action.payload.success,
                    failure: action.payload.failure,
                    intervalId: action.payload.intervalId
                }
            };
        })
            .addCase(throttleSentAction, (state, action) => {
            state[action.payload] = {
                timestamp: Date.now(),
                post: null
            };
        });
    }
});
export default throttleSlice.reducer;
